import { gql } from "@apollo/client";
import { Organization } from "@App/types";

export interface OrganizationPremiumServicesQuery {
  organization: Organization;
}

export const GET_ORGANIZATION_PREMIUM_SERVICES = gql`
    query getOrganizationPremiumServices($organization:ID!, $services: [ID], $driver: UUID, $presetFilters: [PresetFilter], $network: ID) {
        organization(id: $organization) {
            id
            uuid
            premium_services(services: $services, driver: $driver, presetFilters: $presetFilters, networkId: $network) {
                id
                paid
                name
                filterable
                type
                service_type
                show_in_list
            }
        }
    }
`;
